import styled from 'styled-components';

type WrapperProps = {
  height?: number;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  background: #ebeef5;
  position: relative;
  text-align: center;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  padding-bottom: ${({ height }) => (height ? 0 : '56.25%')};
`;

export const ContentWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(calc(-50% + 10px));
`;

export const ErrorMessage = styled.div`
  margin: 0 auto;
  display: block;
  font-weight: bold;
  padding: 0 10px;
  font-size: 16px;
  line-height: 30px;
  color: #919eaa;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const Icon = styled.img`
  max-width: 60px;
  margin: 0 auto 12px;
`;
